import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SimulatorService } from '../../../pre-simulator/services/simulator/simulator.service';
import { ModalGenericComponent } from '../../../shared/components/modal-generic/modal-generic.component';
import { TaxesComponent } from '../../../shared/components/taxes/taxes.component';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { GtmService } from '../../../shared/services/gtm/gtm.service';
import { ConfirmationService } from '../../../vass-core/components/modal/confirmation.service';
import { CommonService } from '../../../vass-core/services/common.service';
import { AcceptationSecondHolderModel } from '../../models/acceptation-second-holder.model';
import { SummarySecondHolderModel } from '../../models/summary-second-holder.model';
import { SummarySecondHolderService } from '../../services/summary-second-holder/summary-second-holder.service';
import { ConfirmDataSecHolderModalComponent } from './components/confirm-data-sec-holder-modal/confirm-data-sec-holder-modal.component';
import { IncorrectDataModalComponent } from './components/incorrect-data-modal/incorrect-data-modal.component';

@Component({
  selector: 'app-summary-second-holder',
  templateUrl: './summary-second-holder.component.html',
  styleUrls: ['./summary-second-holder.component.scss'],
  standalone: false,
})
export class SummarySecondHolderComponent implements OnInit {
  public dataSimulate: SummarySecondHolderModel;
  public totalExpenses: number;
  constructor(
    private _summarySecondHolderService: SummarySecondHolderService,
    private _confirmationService: ConfirmationService,
    private translate: TranslateService,
    private authService: AuthService,
    private _commonService: CommonService,
    private gtm: GtmService,
    private simulatorService: SimulatorService,
  ) {}

  ngOnInit() {
    this._summarySecondHolderService.getSummarySecondHolder().subscribe((data) => {
      this.dataSimulate = data;
      this.gtm.getUserIdGTM(data.holder.email).subscribe(
        (resp) => {
          this.gtm.sendVarGTM({ pageType: 'resultados_2' });
        },
        (error) => {
          this.gtm.sendVarGTM({ pageType: 'resultados_2' });
        },
      );
      this.totalExpenses = this.calculateExpenses();

      this.dataSimulate.holder.nationality = this.simulatorService.findCountry(
        this.dataSimulate.holder.nationality,
      );
      this.dataSimulate.holder.country = this.simulatorService.findCountry(
        this.dataSimulate.holder.country,
      );
    });
  }

  private calculateExpenses() {
    if (this.dataSimulate && this.dataSimulate.mortgageSimulateResponse.mortgageResult) {
      return (
        parseFloat(
          this.dataSimulate.mortgageSimulateResponse.mortgageResult.expenses.mortgage
            .total,
        ) +
        parseFloat(
          this.dataSimulate.mortgageSimulateResponse.mortgageResult.expenses.trading
            .total,
        )
      );
    }
    return 0;
  }

  public openModal(type: string) {
    // Abrir modal
    let modalComponent: Object;
    let titleModal: string;
    const dataModal = {
      type,
      savingsMade: this.dataSimulate.savingsMade,
      dataSimulate: this.dataSimulate.mortgageSimulateResponse.mortgageResult,
      error: '',
      message: '',
    };

    switch (type) {
      case 'taxes': {
        titleModal = this.translate.instant('summary_sec_holder_taxes');
        modalComponent = TaxesComponent;
        break;
      }
      case 'editData': {
        titleModal = this.translate.instant('summary_sec_holder_btn_modify');
        modalComponent = IncorrectDataModalComponent;
        break;
      }
      case 'deleteData': {
        titleModal = this.translate.instant('summary_sec_holder_btn_incorret_data');
        modalComponent = IncorrectDataModalComponent;
        break;
      }
      case 'confirmData': {
        titleModal = this.translate.instant('summary_sec_holder_btn_confirm_data');
        modalComponent = ConfirmDataSecHolderModalComponent;
        break;
      }
      case 'logout': {
        titleModal = this.translate.instant('summary_sec_holder_modal_logout_title');
        modalComponent = ModalGenericComponent;
        dataModal.message = 'summary_sec_holder_modal_logout_msg';
        break;
      }
      default:
        return;
    }
    const options: Object = {
      showHeader: true,
      header: titleModal,
      closeOnEscape: true,
      closable: true,
      styleClass: 'modal-class',
      cancelButton: false,
      acceptButton: false,
    };
    this._confirmationService.confirm(<any>{
      component: modalComponent,
      options: options,
      data: dataModal,
      accept: (data) => {
        if (data) {
          let body: AcceptationSecondHolderModel;
          switch (type) {
            case 'editData': {
              if (data && data.ref) {
                body = {
                  response: 'MTG_E04.4',
                  description: data.data,
                };
              }
              break;
            }
            case 'deleteData': {
              if (data && data.ref) {
                body = {
                  response: 'MTG_E04.5',
                  description: data.data,
                };
              }
              break;
            }
            case 'confirmData': {
              if (data && data.ref) {
                body = {
                  response: 'MTG_E05',
                  description: '',
                  cirbe: data.data.cirbe,
                  fipreDocDownloadDate: String(new Date().getTime()),
                  allowPersonalData: null,
                  allowPublicity: null,
                  allowPrivacyPolicy: true,
                  allowInsuranceCost: true,
                };
              }
              break;
            }
            default:
              return;
          }

          this._summarySecondHolderService.acceptationSecondHolder(body).subscribe(
            (response) => {
              this.dataSimulate.status = response.caseStage;
              data.ref.accept();
              if (response.caseStage === 'MTG_E04.5') {
                this._summarySecondHolderService.deleteSecondHolder().subscribe(
                  (data) => {
                    this.openModal('logout');
                    this.authService.logout();
                  },
                  (err) => {},
                );
              } else {
                this._commonService.sendNotification({
                  key: 'save-ok-second-holder',
                  severity: 'success',
                  position: 'top-center',
                  summary: this.translate.instant('summary_second_holder_toast_title'),
                  time: 5000,
                  detail: this.translate.instant('summary_second_holder_toast_msg'),
                });
              }
            },
            (err) => {
              const error_msg = err && err.message ? 'error_' + err.message : '';
              if (this.translate.instant(error_msg) === error_msg) {
                data.ref.data.error = this.translate.instant('error_page_err_generic');
              } else {
                data.ref.data.error = this.translate.instant('error_msg');
              }
            },
          );
        }
      },
      reject: () => {},
    });
  }
}
